/**
 * 
 * 所有state的异步设置
 * 
 */

/*eslint no-unused-vars: "off"*/
export default {
	getShopList({
		commit
	}){
		return new Promise((resolve,reject)=>{
			
		})		
	}

};


// WEBPACK FOOTER //
// ./src/store/actions.js